var bold = bold || {};


/*==============================================================================
  GENERATE DISCOUNT
  * Promotional discount generation
==============================================================================*/
bold.generateDiscount = function(params){
  var hash = bold.paramExists('hash');
  var code = bold.paramExists('code');

  if(params.security == hash){
    var data = {
      customer_id: params.customer_id,
      customer_email: params.customer_email,
      hash: params.security,
      code: code,
      myshopify_url: params.myshopify_url
    }

    $.ajax({
      url: 'https://zippo-app.test.boldapps.net/front_end/api/discount',
      type: 'post',
      dataType: 'json',
      data: JSON.stringify(data),
      success: function(data){
        if(data.status=='success'){
          $('.coupon-code-input').val(data.message.discount_code);
          if(data.message.type=='percentage'){
            $('.coupon-value').text(Math.round(data.message.value) + '%');
          }
          else {
            $('.coupon-value').text('$' + data.message.value);
          }
          if($('.coupon-applied').length > 0){
            if($('.coupon-code').attr('data-coupon') == data.message.discount_code){
              $('.coupon-applied').addClass('coupon--green')
            }
            else {
              $('.coupon-applied').addClass('coupon-button').text('Replace Current Coupon');
            }
          }
        }
        else {
          $('.discount-errors').hide();
          $('.discount-errors .errors').text('You are not eligible for this discount');
        }
      }
    });
  }
  else {
    $('.coupon-is-active').hide();
    $('.coupon-is-inactive').show();
  }
  /*==============================================================================
    Apply coupon code to cart
  ==============================================================================*/
  $(document).on('click', '.coupon-button', function(){
    var couponCode = $('.coupon-code-input').val();
    $.ajax({
      type: 'POST',
      data: "attributes[coupon_code]="+couponCode,
      dataType: 'json',
      url: '/cart/update.js',
      success: function(cart) {
        location.reload();
      }
    });
  });
}



/*==============================================================================
  UTM Stuff
==============================================================================*/
var urlParams = window.location.search.substring(1);
if(urlParams.indexOf('utm_')>-1){
  urlParams = urlParams.split('&');
 var attributes = {};
 for(param in urlParams){
   var key = urlParams[param].split('=')[0];
   var value = urlParams[param].split('=')[1];
   if(key.indexOf('utm')>-1){
     attributes[key] = value;
    }
  }
  $.ajax({
    url: '/cart/update.js',
    type: 'post',
    dataType: 'json',
    data: {
      attributes: attributes
    }
  });
}

$(document).ready(function(){

  $( "hr" ).each(function( index ) {
    $(this).attr('role', 'presentation');
  });



  /*==============================================================================
    Home page slider. Uses slick.min.js/slick.scss.
  ==============================================================================*/
  $('.home-slider').slick({
    slide: '.home-slide',
    appendArrows: '.home-slider-arrows-inner',
    prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="Previous Slide"><img src="//cdn.shopify.com/s/files/1/0272/1605/2267/files/arrow-left-thumb.png" /></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="Next Slide"><img src="//cdn.shopify.com/s/files/1/0272/1605/2267/files/arrow-right-thumb.png" /></button>',
    dots: true,
    appendDots: '.home-slider-dots-inner',
    fade: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: 'linear'
  });

  $('.slick-dots li button').prepend('Slide ');
  //$('.slick-dots li[aria-selected='true'] button').append(' Selected');


  $('.play').hide();

		$('.pause').on('click', function() {
	    $('.home-slider').slick('slickPause');
			$('.pause').hide().attr('aria-pressed', 'true');
			$('.play').show().attr('aria-pressed', 'false').focus();
		});

		$('.play').on('click', function() {
	    $('.home-slider').slick('slickPlay');
			$('.play').hide().attr('aria-pressed', 'true');
			$('.pause').show().attr('aria-pressed', 'false').focus();
		});

  $('.slick-track').removeAttr('role');
  $('.slick-slide').removeAttr('role');

  $('.home-slider').on('afterChange', function(event, slick, currentSlide, nextSlide, previousSlide){

    $('.slick-dots li').each(function() {

      	current = '#slick-slide0' + 	currentSlide;
    	dot_text = $(this).attr("id");
      	dot_number = +dot_text.replace('slick-slide0', '') + 1;
        if($(this).is(current)){
          $(this).find('button').text('Slide ' + dot_number + ' Selected');
        }else{
         $(this).find('button').text('Slide ' + dot_number);
        }

    });


    setTimeout(function(){
      $('.slick-track').removeAttr('role');
      $('.slick-slide').removeAttr('role');

    }, 500);


  });

  /*==============================================================================
    Instagram photos
  ==============================================================================*/
//   $.ajax({
//     url: 'https://zippo-app.boldapps.net/front_end/api/instagram',
//     type: 'get',
//     data: {
//       'user_id': '237333290',
//       'access_token': '237333290.1677ed0.5bb4f1fec35f49bbb573724e6d3764ab',
//       'filter': 'zippo'
//     },
//     success: function(response){
//       console.log(response);
//       $('.social-boxes img').each(function(index){
//         var image = response.message[index].images['standard_resolution'].url,
//             likes = response.message[index].likes.count,
//             comments = response.message[index].comments.count;
//         console.log(index, image);
//         $(this).attr('src', image);
//         $(this).prev().find('.social-box-type-likes').html(likes);
//         $(this).prev().find('.social-box-type-comments').html(comments);
//       });
//     },
//     error: function(){
//       $('.social-boxes').remove();
//     }
//   });


  /*==============================================================================
    Red line under the search in the header on focus
  ==============================================================================*/
  $('.header-bottom-search-input').on('focus', function(){
    $(this).closest('form').addClass('focused');
  });
  $('.header-bottom-search-input').on('blur', function(){
    $(this).closest('form').removeClass('focused');
  });

   $('script').each(function() {

     $(this).removeAttr('type');

    });

  /*==============================================================================
    Mobile menu (open/close)
  ==============================================================================*/
  $('.menu-drawer-nav-link--has-dropdown').click(function(e){
    if($(this).next('.menu-drawer-nav-dropdown').hasClass('open')){
      $(this).find('i').attr('class', 'icomoon-chevron-down');
      $(this).attr('aria-expanded', false);
    }
    else {
      $(this).find('i').attr('class', 'icomoon-close');
      $(this).attr('aria-expanded', true);
    }
    $(this).next('.menu-drawer-nav-dropdown').toggleClass('open');
    e.preventDefault();
  });
   /*==============================================================================
    Added by v.shala@nexus-united.com 14-Dec'2020. quantity on pdp and cart page
  ==============================================================================*/
    // This button will increment the value
    $('.qtyplus-v').click(function(e){
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name='+fieldName+']').val());
      // If is not undefined
      if (!isNaN(currentVal)) {
          // Increment
          $('input[name='+fieldName+']').val(currentVal + 1);
      } else {
          // Otherwise put a 1 there
          $('input[name='+fieldName+']').val(1);
      }
  });
  // This button will decrement the value till 0
  $(".qtyminus-v").click(function(e) {
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name='+fieldName+']').val());
      // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > 1) {
          // Decrement one
          $('input[name='+fieldName+']').val(currentVal - 1);
      } else {
          // Otherwise put a 1 there
          $('input[name='+fieldName+']').val(1);
      }
  });
  /*==============================================================================
    Generic open/close on button click. Add [data-button-for="NAME"] on your
    activator, and [data-opens-for="NAME"] on the element it displays.
  ==============================================================================*/
  $('.page-sidebar-sublist').attr('aria-expanded', false);
  $(document).on('click', '[data-button-for]', function(){
    var buttonFor = $(this).attr('data-button-for'),
        opensFor = $('[data-opens-for="'+buttonFor+'"]');
    $(this).attr('aria-expanded', false);
    if(opensFor.is(':visible')){
      $(this).removeClass('button--active');
      opensFor.hide();
      opensFor.hide().attr('aria-expanded', false);
      $(this).attr('aria-expanded', false);
    }
    else {
      $(this).addClass('button--active');
      opensFor.show();
      opensFor.show().attr('aria-expanded', true);
      $(this).attr('aria-expanded', true);
    }
  });

  $('.button--active').attr('aria-expanded', 'true');

  $(document).on('keypress', '[data-button-for]', function(e){
    if(e.which == 13) {
      var buttonFor = $(this).attr('data-button-for'),
          opensFor = $('[data-opens-for="'+buttonFor+'"]');
      $(this).attr('aria-expanded', false);
      if(opensFor.is(':visible')){
        $(this).removeClass('button--active');
        opensFor.hide();
        opensFor.hide().attr('aria-expanded', false);
        $(this).attr('aria-expanded', false);
      }
      else {
        $(this).addClass('button--active');
        opensFor.hide();
        opensFor.show().attr('aria-expanded', true);
        opensFor.find('li:first-child > a').focus();
        $(this).attr('aria-expanded', true);
        if($(this).hasClass('mobile-header--search')){
        	opensFor.find('input').focus();
        }
      }
    }
  });

  /*==============================================================================
    Generic read more button
  ==============================================================================*/
  $(document).on('click', '[data-read-more-trigger]', function(){
    var buttonFor = $(this).attr('data-read-more-trigger'),
        opensFor = $(this).closest('.product-form').find('[data-read-more="'+buttonFor+'"]');
    if(opensFor.hasClass('show-all')){
      opensFor.removeClass('show-all');
      $(this).html('Read more <i class="icomoon-chevron-down"></i>');
    }
    else {
      opensFor.addClass('show-all');
      $(this).html('Read less <i class="icomoon-chevron-up"></i>');
    }
  });

  /*==============================================================================
    Product page slider on mobile only. Uses slick.min.js/slick.scss.
  ==============================================================================*/
  $('.mobile-product-images').slick({
    slide: '.mobile-product-image-slide',
    arrows: false,
    dots: true,
    appendDots: '.product-slider-dots-inner'
  });

  /*==============================================================================
    Product page vertical slider for thumbnails.  Uses slick.min.js/slick.scss.
  ==============================================================================*/
  $('.product-thumbnails').slick({
    slide: '.product-thumb',
    arrows: true,
    vertical: true,
    slidesToShow: 5,
    slidesToScroll: 5,
  });

  /*==============================================================================
    Featured products slider. Uses slick.min.js/slick.scss.
  ==============================================================================*/
  $('.featured-products').slick({
    slide: '.featured-product',
    slidesToShow: 6,
    slidesToScroll: 6,
    dots: false,
    centerMode: true,
    centerPadding: '20px',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }
  ]
  });

  /*==============================================================================
    Opens the "video" product thumbnail in a modal window.
    Uses Magnific Popup in base.js.liquid.
  ==============================================================================*/
  $('.product-thumb-video-link').magnificPopup({
    type: 'iframe',
    iframe: {
      patterns: {
	       youtube: {
	       	index: 'youtube.com',
	       	id: 'v=',
	       	src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
	       }
	     }
    },
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  /*==============================================================================
    Opens the featured product in a modal window for large-scale viewing.
    Uses Magnific Popup in base.js.liquid.
  ==============================================================================*/
  $('.product-featured-gallery').magnificPopup({
    type: 'image',
    delegate: 'a',
    mainClass: 'mfp-fade',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
    },
    image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			titleSrc: function(item) {
				return item.el.attr('title');
			}
		}
  });

  /*==============================================================================
    "More" link in the main nav if the nav items are too long for alloted space
  ==============================================================================*/
  checkNavigationSizing();

	$(window).resize(function(event) {
		checkNavigationSizing();
	});

	function checkNavigationSizing(){
		var navWidth = $('.main-nav').width()-10;
		var searchWidth = $('.header-bottom-search').outerWidth()+20;
		var navArea = navWidth;
		var navItemWidth = 0;
		var showMore = false;
		var moreLink = '<li class="nav-item more-link">More <i class="icomoon-caret-down"></i></li>';
		var moreLinks = '';

		$('.main-nav .empty').before(moreLink);
		var moreLinkWidth = 52+40;
		$('.more-link').remove();

		$('.main-nav .nav-item').each(function(){
			if($(this).hasClass('search')==false && $(this).hasClass('empty')==false){
        var combinedWidth = navItemWidth + $(this).width() + 40 + moreLinkWidth;
				if(combinedWidth >=navArea){
					$(this).hide();
					showMore = true;
					moreLinks += '<li class="nav-dropdown-item">'+$('<div>').append($(this).find('a').first().clone()).html()+'</li>';
				}
				else {
					$(this).show();
					showMore = false;
				}
				navItemWidth += $(this).width() + 40;
			}
		});

		moreLink = '<li class="nav-item more-link nav-item--has-dropdown"><a class="nav-link" href="">More <i class="icomoon-caret-down"></i></a><div class="nav-dropdown nav-dropdown--normal"><ul class="container">'+moreLinks+'</ul></div></li>';

		if(showMore==true){
			$('.main-nav .empty').before(moreLink);
		}
		else {
			$('.more-link').remove();
		}
	}

  /*==============================================================================
    "Menu aim" is here to help the dropdown menus stay open if a users quickly
    hovers off of it while trying to click a sub link.
    Uses jquery-menu-aim.js.
  ==============================================================================*/
  $('.main-nav').menuAim({
    rowSelector: '.nav-item',
    submenuSelector: '.nav-item--has-dropdown',
    activate: function(navItem){
      $(navItem).find('.nav-dropdown').addClass('nav-dropdown--show');
      $(navItem).find('> .nav-link').addClass('nav-link--hover');
    },
    deactivate: function(navItem){
      $(navItem).find('.nav-dropdown').removeClass('nav-dropdown--show');
      $(navItem).find('> .nav-link').removeClass('nav-link--hover');
    },
    exitMenu: function(){
      return true;
    },
    submenuDirection: 'below'
  });

  $( ".main-nav > .nav-item" ).focusin(function() {
    $('.nav-dropdown').removeClass('nav-dropdown--show');
    $('.nav-link').removeClass('nav-link--hover');

  	$(this).find('.nav-dropdown').addClass('nav-dropdown--show');
    $(this).find('> .nav-link').addClass('nav-link--hover');

  });




  /*==============================================================================
    Collection filters and sorts
  ==============================================================================*/
  $('.view-button').click(function(){
    if($(this).hasClass('square-view')){
      $.ajax({
        type: 'POST',
        data: "attributes[product_view]=grid",
        dataType: 'json',
        url: '/cart/update.js',
        success: function(cart) {
          window.location.href = document.URL;
        }
    	});
    }
    else {
      $.ajax({
        type: 'POST',
        data: "attributes[product_view]=list",
        dataType: 'json',
        url: '/cart/update.js',
        success: function(cart) {
          window.location.href = document.URL;
        }
    	});
    }
  });

  $('.view-button').on('keypress', function(e){
    if(e.which == 13) {
        if($(this).hasClass('square-view')){
          $.ajax({
            type: 'POST',
            data: "attributes[product_view]=grid",
            dataType: 'json',
            url: '/cart/update.js',
            success: function(cart) {
              window.location.href = document.URL;
            }
        	});
        }
        else {
          $.ajax({
            type: 'POST',
            data: "attributes[product_view]=list",
            dataType: 'json',
            url: '/cart/update.js',
            success: function(cart) {
              window.location.href = document.URL;
            }
        	});
        }
      }
      else {
      }
  });

  $('.items-per-page').change(function(){
    var itemsPerPage = $(this).val();
    $.ajax({
      type: 'POST',
      data: "attributes[product_per_page]="+itemsPerPage,
      dataType: 'json',
      url: '/cart/update.js',
      success: function(cart) {
        bold.updateUrlParm('page', 1);
      }
  	});
  });

  $('.search-items-per-page').change(function(){
    var itemsPerPage = $(this).val();
    $.ajax({
      type: 'POST',
      data: "attributes[search_items_per_page]="+itemsPerPage,
      dataType: 'json',
      url: '/cart/update.js',
      success: function(cart) {
          bold.updateUrlParm('page', 1);
      }
  	});
  });
  $('.tag-filter').change(function(){
    var filters = [];
    $('.tag-filter').each(function(){
      if($(this).val()!=''){
        filters.push($(this).val());
      }
    });
    filters = filters.join('+');
    var new_url = collectionUrl + '/' + filters;
    window.location = new_url.replace('//','/');
  });

  $('.mobile-tag-filter').change(function(){
    var target = $(this).attr('data-target');
    $('[data-filter="'+target+'"]').val($(this).val()).change();
  });

  /*==============================================================================
    Twitter feed on the home page. Pulls the 2 latest tweets and populates the
    corresponding boxes. Uses twitterFetcher.min.js.
  ==============================================================================*/
  var config5 = {
    "profile": {"screenName": 'Zippo'},
    "domId": '',
    "maxTweets": 2,
    "enableLinks": true,
    "showUser": false,
    "showTime": true,
    "showRetweet": false,
    "customCallback": handleTweets,
    "showInteraction": false
  };

  function handleTweets(tweets) {
    var x = tweets.length,
        n = 0;
    while(n < x) {
      $('#social-box-tweet-'+n).html(tweets[n]);
      n++;
    }
  }
  twitterFetcher.fetch(config5);

  /*==============================================================================
    Re-Order from the account pages.
  ==============================================================================*/
  var itemsToAdd = [];
	var addItemsToTheCart = function(){
		if(itemsToAdd.length){
			var item = itemsToAdd.pop();
			$.ajax({
				url: '/cart/add',
				dataType: 'json',
				type: 'post',
				data: item,
				success: function(error){
          addItemsToTheCart();
        },
				error: function(error){
          addItemsToTheCart();
        }
			});
		}
		else {
      bold.updateCartCount();
      $.getJSON('/cart', function(cart) {
        $.ajax({
          url: '/cart',
          type: 'get',
          dataType: 'html',
          data: {
            view: "drawer"
          },
          success: function(cart){
            bold.showCartDrawer(cart);
            $('.reorder .icomoon--spin-counter-clockwise').removeClass('icomoon--spin-counter-clockwise');
          }
        });
      });
		}
	}

	$('.reorder--trigger').click(function(){
    $(this).find('i').addClass('icomoon--spin-counter-clockwise');
		itemsToAdd = [];

		$(this).closest('.order-wrapper').find('.reorder-item').each(function(){
			var quantity = parseInt($(this).val(), 10);
			var id = $(this).attr('data-variant-id');
      var properties = $(this).attr('data-properties');

			if(quantity){
				itemsToAdd.push({ id: id, quantity: quantity, properties: JSON.parse(properties) });
			}
		});

		if(itemsToAdd.length){
			addItemsToTheCart();
		}
		else {
			alert('All quantities are set to zero.');
		}
	});

  /*==============================================================================
    COUNTRY/PROVINCE CHANGE
  ==============================================================================*/
  var selectedCountry = {};
  $('.country-select').change();
  $('.country-select').on("change", function(){
    selectedCountry = Countries[$(this).val()];
    $('.province-label').text(selectedCountry.province_label);
  });

  /*==============================================================================
    Cancel bundle purchase (closes modal and buys the product on the page)
  ==============================================================================*/
  $('.cancel-bundle').on('click', function(){
    $.magnificPopup.close();
  });

});

bold.initBundle = function(){
  $('.bundle-form select').off();
  $('.bundle-form select').on('change', function(){
    var $form = $(this).parents('.bundle-form');
    var dataBundle = $form.find('.bundle-id').attr('data-bundle');
    var bundleId = dataBundle;

    $form.find('select').each(function(){
      bundleId += '_' + $(this).val();
    });

    $form.find('.bundle-id').val(bundleId);
  });
  $('.bundle-form select').change();
}

$(window).load(function(){
  $('.country-select').change();
});

function checkFees(){
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    async: true,
    type: 'GET',
    success: function(cartItems){
      var customizerIds = [],
          itemQuantities = [];
      $.each(cartItems.items, function(index, item){
        $.each(item.properties, function(property, value){
          if(property == "_customizer_master"){
            var isInArray = $.inArray(item.properties["_customizer_group_id"], customizerIds);
            if(isInArray == -1){
              customizerIds.push(item.properties["_customizer_group_id"]);
            }
          }
        });
      });
      var itemShouldBeRemoved = false;
      $.each(cartItems.items, function(index, item){
        var needsToBeRemoved = false;
        $.each(item.properties, function(property, value){
          if(property == "_customizer_group_id"){
            var isInArray = $.inArray(value, customizerIds);
            if(isInArray == -1){
              needsToBeRemoved = true;
              itemShouldBeRemoved = true;
            }
          }
        });
        if(needsToBeRemoved){
          itemQuantities.push(0);
        }
        else {
          itemQuantities.push(item.quantity);
        }
      });
      if(itemShouldBeRemoved){
        jQuery.post('/cart/update.js', {updates: itemQuantities});
        location.reload();
      }
    },
    error: function(error){
      console.log(error);
    }
  });
}
/* Added by v.shala@nexus-united.com - 21.01.2021 */
$(window).load(function(){
  //fixed for ajax cart
  $('body').on('click','.cart-drawer-shipping-notice > span',function(e){
    e.preventDefault();
    window.open('https://zipponl.myshopify.com/pages/verzendinformatie', '_blank');
  });
});
